import { Button } from "shared/Components/button";
import Modal from "shared/Components/modal";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { pending, success } from "helper/icons";
import { updateHostRoleMutation } from "redux/features/memberSlice/memberGql";
import { client } from "helper/apolloConfig";

export function ApplyForHostModal({modalRef}) {
  const { auth } = useSelector((state) => state);

  const [applied, setApplied] = useState(false);

  const [message, setMessage] = useState('');

  const [loading, setLoading] = useState(false);
  
  const [error, setError] = useState(false);

  const [isModalClosed, setIsModalClosed] = useState(false);

  const handleApply = async () => {
    const authId = auth?.memberReducer?.memberDetails.authId;
    
    setLoading(true);
    try {
      const result = await client.mutate({
        mutation: updateHostRoleMutation,
        variables: {
          authId,
        },
      });
  
      if (result?.data?.requestToUpdateRole?.message) {
        setMessage("Thank you for requesting more information on Hosting a trial. We will be in touch with you shortly.")
        setApplied(true);
      } else {
        setMessage("Unexpected response");
        setError(true);
      }
    } catch (err) {
      setMessage("You have already submitted a request for more information on Hosting a trial. We will be in touch with you shortly");
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(()=> {
    if (isModalClosed) {
      setError(false);
      setApplied(false);
    }
  }, [isModalClosed])

  const onCloseModal = () => {
    modalRef.current.closeModal();
  }

  return (
    <Modal
      extraClass={`pt-0`}
      headerClass="sticky top-6 left-100 z-50"
      iconPosition="right-0"
      ref={modalRef}
      setIsModalClosed={setIsModalClosed}
    >
        {applied || error ? (
          <div className="p-8 pb-0 flex flex-col items-center m-auto">
            <img
              src={error ? pending : success}
              alt=""
              className="w-12 h-12 mb-4"
            />
            <span className="text-md font-semibold text-gray-900 text-center">
              {message}
            </span>
          </div>
        ) : (
          <div className="p-8 pb-0 items-center m-auto">
            <span className="text-xl font-semibold text-gray-900">
              Do you want to become a Host?
            </span>
            <div className="flex gap-2 justify-center mt-4"> 
              <Button
                onClick={handleApply}
                disabled={loading}
                onlyDisabled={applied}
                label="Yes"
                width="w-[120px]"
              />
              <button 
                className="w-[120px] border border-gray-300 rounded-md hover:bg-gray-300"
                onClick={onCloseModal}
              >
                No
              </button>
            </div>
          </div>
        )}
    </Modal>
  );
}
